var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-modal',{on:{"closeModal":function($event){return _vm.$emit('closeModal')}}},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("delivery.incident_detail")))]),_c('dynamic-form-renderer',{attrs:{"fields":_vm.incidentDetails.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }